import { Component } from '@angular/core';
import { IFilterComp, IFloatingFilterParams } from 'ag-grid-community';
import { AgFloatingFilterComponent } from 'ag-grid-angular';
import { AccountNumberPipe } from '../../../../shared/pipes/account-number.pipe';
import { AccountSearchComponent } from '../../../../shared/components/account-search/account-search.component';

@Component({
    selector: 'account-filter-component',
    templateUrl: './account-filter.component.html',
    styleUrls: ['./account-filter.component.scss'],
    standalone: true,
    imports: [AccountSearchComponent]
})
export class AccountFilterComponent implements AgFloatingFilterComponent {
  params: IFloatingFilterParams;
  currentValue: any;
  selectedAccountWithName: string;
  accountNumberPipe = new AccountNumberPipe();

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  onParentModelChanged(parentModel: any): void {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = null;
    } else {
      this.currentValue = parentModel.filter;
    }
  }

  accountSelected(event): void {
    if (event != null) {
      this.currentValue = this.accountNumberPipe.transform(event.accountId);
      this.params.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged('equals', this.currentValue);
      });
    } else {
      this.currentValue = null;
      this.params.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged(null, null);
      });
    }
  }
}
